export const FLAG_FEATURE_ENABLED: 'global/FLAG_FEATURE_ENABLED' = 'global/FLAG_FEATURE_ENABLED'

export type FlagFeatureEnabledAction = {
  payload: {
    feature: string,
  },
  type: typeof FLAG_FEATURE_ENABLED,
}

export type GlobalActions = FlagFeatureEnabledAction

export function flagFeatureEnabled(feature: string): FlagFeatureEnabledAction {
  return { payload: { feature }, type: FLAG_FEATURE_ENABLED }
}
